import { useEffect, useState } from "react";
import Cards from "../../../common/Cards";
import Button from "../../../form/Button";
import Switch from "../../../form/Switch";
import PasswordSettings from "./PasswordSettings";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";
import { userStatusChange } from "../../../../services/userService";

const AdvanceSettings = ({ details, getResponse, loading }) => {
  const [checked, setChecked] = useState(false);
  const {
    mutate: onSubmit,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const { ...rest } = val;
      delete rest?._id;
      return await userStatusChange(
        details?._id && { ids: [details?._id], ban: checked }
      );
    },
    onSuccess: (res) => {
      getResponse(res);
      if (res?.status === 200) {
        toast.success(res?.message);
      }
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    if (details?._id) {
      setChecked(details?.isBanned?.isBanned || false);
    }
  }, [details?._id]);

  return (
    <>
      <PasswordSettings {...{ details, getResponse, loading }} />
      <div className="relative mt-2">
        <Cards
          title="Account Restriction Settings"
          description="Manage how user restrictions are applied, including banning options and related controls."
        >
          <div className="flex items-center gap-2">
            <span className="font-medium text-sm text-primary">
              {" "}
              {checked ? "Suspend User Account" : "Active User Account"}
            </span>
            <Switch
              checked={checked}
              disabled={isLoading || loading}
              onChange={(e) => {
                setChecked(e?.target?.checked);
              }}
            />
          </div>
          <div className="mt-2 flex justify-end">
            <Button
              buttonFunction={onSubmit}
              buttonClasses={"min-w-36"}
              buttonLabel={"Save"}
              {...((isLoading || loading) && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
            />
          </div>
        </Cards>
      </div>
    </>
  );
};

export default AdvanceSettings;
